<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      alert-type="error"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      
    </v-row>
    <v-row>
      <v-col
        cols="11"
        lg="8"
        md="7"
        sm="11"
        class="mx-auto pb-0"
      >
        <p class="text-h5 font-weight-bold">
          {{ $t('chooseActivities') }}
        </p>
        <p class="text-body-1 greytext--text">
          {{ $t('titleActivitiesFromHub') }}
        </p> 
        <p class="text-body-1 ml-4 md-ml-10">
          <input
            v-model="allSelected"
            data-testid="activity-select-all"
            type="checkbox"
            :disabled="!activities.length"
            @click="selectAll"
          > {{ $t('chooseAllActivities') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="2" 
        lg="2"
        md="3"
        sm="10"
        class="mx-auto pt-10"
      >
        <SearchBarExpanding @input="searchActivities" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row v-if="mobile()">
      <v-col cols="11" class="d-flex mx-auto">
        <SearchBarExpanding @input="searchActivities" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="11"
        class="mx-auto"
      >
        <v-row align="center">
          <v-col
            v-for="item in activities"
            :key="item.id"
            cols="12"
            sm="6"
            lg="3"
            xl="3"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                v-if="item.attributes"
                data-testid="hub-activities"
                :elevation="hover ? 12 : 2"
                class="mx-auto rounded-xxl hub-activity"
                height="290"
                rounded="xxl"
                :class="{'activity-grid':activityIds.includes(item.id)}"
              >
                <v-responsive class="rounded-b-0">
                  <v-checkbox
                    :id="item.id"
                    v-model="activityIds"
                    class="mx-5 mt-5 pt-0 activity-grid-chk"
                    data-testid="activity-id-checkbox"
                    style="position: absolute;z-index: 1;right: 0;"
                    :value="item.id"
                    @click="select"
                  />
                  <label :for="item.id"> 
                    <v-img
                      class="white--text align-end"
                      :src="(item.attributes.image) ? item.attributes.image : require('../../assets/cover-activity.jpg')"
                      height="195px"
                    />
                  </label>
                </v-responsive>
                <v-card-text class="text--primary">
                  <v-card-title class="text-left pa-0 no-break">
                    <v-clamp
                      autoresize
                      :max-lines="2"
                    >
                      {{ item.attributes.title }}
                    </v-clamp>
                  </v-card-title>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="activities && activities.length == 0 && !loadingData">
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <div
          :class="{'custom-center': !mobile()}"
          class="greytextlight--text text-h6 text-md-h5 font-weight-bold mx-auto pa-4"
        >
          {{ $t('hubNoActivityMsg') }}
        </div>
      </v-col>
    </v-row>


    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="activityInfo.total"
      :page-number="activityInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />

    <v-footer
      fixed
      color="white"
    >
      <v-row>
        <v-col
          fixed
          align="center"
        >
          <FormFixedFooter
            next-button-text="add"
            :loading="loading"
            :cancel-button-link="'/hub/'+hubID"
            @proceedSubmit="sharingSetting == 1 ?
                showDialogBeforeAddActivities() : addActivities(false)"
                
          />
        </v-col>
      </v-row>
    </v-footer>
    <ConfirmationDialog
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      cd-submit-btn-color="accent"
      data-testid="confirmation-dialog"
      @input="dialogVisible=false"
      @close="addActivities(false)"
      @proceedSubmit="addActivities(true)"
    />
  </nav>
</template>

<script>
import VClamp from 'vue-clamp'
import i18n from '../../plugins/i18n'
import Pagination from '../../components/Pagination'
import FormFixedFooter  from '../../components/FormFixedFooter'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getHub, getActivitiesNotAddedToHub,getActivitiesNotAddedToHubWithKeyword,addActivitiesToHub } from '../../api/hubApi'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import SearchBarExpanding from '../../components/SearchBarExpanding'

export default {
  components: {
    Pagination,
    FormFixedFooter,
    VClamp,
    AlertMessages,
    ConfirmationDialog,
    SearchBarExpanding
  },
  mixins: [repeatedMethodsMixin],
  data () {
    return {
      alertMsg:'',
      alertType:'',
      alertValue:false,
      allSelected: false,
      loadingData: false,
      activityIds : [],
      activities: [],
      pageNumber: 1,
      size: 12,
      hubID: this.$route.params.id,
      activityInfo: { 
        currentPage: 1,
        total: 0,
      },
      dialogVisible: false,
      sharingSetting: '',
      confirmationDialogTitle: '',
      confirmationDialogText: '',
      confirmationDialogCancelBtn: '',
      confirmationDialogSubmitBtn: '',
      keyword: '',
      paginationKey: ''
    }
  },
  computed: {
     loading(){
          if(!this.activities.length || !this.activityIds.length){
              return true
          }
          return false
      }
  },
  async created(){
        this.loadingData = true
        await this.getHub()
        await this.fetchActivities(this.keyword)
        this.loadingData = false
  },
  methods:{
      selectAll() {
          this.activityIds = []
          if (!this.allSelected) {
            for (var activity in this.activities) { 
              this.activityIds.push(this.activities[activity].id)
            }
          }
      },
      select() {
        this.allSelected = false
      },
      async getHub(){
          try {
              const response = await getHub(this.hubID)
              if(response.status == 200) {
                  this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
              }  
          } catch (e) {
              if(e.response){
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
              } 
          }
      },
      async addActivities(autoShare) {
        try {
            let data = {
                data: {
                    type: "activities", 
                    attributes: {
                        activities_uuid: this.activityIds,
                        auto_share: autoShare
                    },
                }
            }
            const response = await addActivitiesToHub(this.hubID, data)

               if(response.status){
                  if(response.status == 200) {
                      this.$router.push({name: 'ViewHub', params: {successfullyAddedActivities: true}})
                   }
               }
          } catch (e) {
              if(e.response){
                  if(e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                  } else {
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  }
              }
          }
      },
      async fetchActivities(keyword){
        let response;
          try {
            if (keyword == '') {
              response = await getActivitiesNotAddedToHub(this.hubID,this.size,this.pageNumber)
            } else {
              response = await getActivitiesNotAddedToHubWithKeyword(this.hubID,this.size,this.pageNumber,keyword)
            }
             
              if(response.status){
                  if(response.status == 200) {
                    this.activities = response.data.data
                    window.scrollTo(0,0)
                    this.activityInfo = response.data.meta
                  }
              }  
                      
          } catch (e) {
              
              if(e.response){
                  if(e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else if (e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                  } else {
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  }
              }
          }
      },
      resetSearch(){
        this.activityInfo.currentPage = 1
        this.pageNumber = 1
        this.keyword = ''
        this.fetchActivities(this.keyword)
        this.paginationKey = Date.now()
        return
      },
      handlePageChange(value){
          this.loadingData = true
          this.activityInfo.currentPage = value
          this.pageNumber = value
          this.fetchActivities(this.keyword)
          this.loadingData = false
      },

      showDialogBeforeAddActivities(){
          this.dialogVisible = true
          this.confirmationDialogTitle = i18n.t('confirmationDialogTitleHubAutoShare')
          this.confirmationDialogText = i18n.t('confirmationDialogTextHubAutoShare')
          this.confirmationDialogSubmitBtn = i18n.t('yes')
          this.confirmationDialogCancelBtn = i18n.t('continueWithout')
      },
      searchActivities(keyword) {
        this.keyword = keyword
        this.activityInfo.currentPage = 1
        this.pageNumber = 1
        this.fetchActivities(this.keyword)
        this.paginationKey = Date.now()
      }
  }
}
</script>
<style>
.activity-grid-chk .v-input--selection-controls__input i.v-icon {
    background: #fff;
    height: 20px;
    width: 20px;
    color: #ffffff;
    border-radius: 2px;
    box-shadow: 0 0 15px rgb(0 0 0 / 30%);
}
.activity-grid-chk  .v-input--selection-controls__input{
  margin-right: 0px;
  height: 20px;
  width: 20px;
  padding-left: 2px;
}
.activity-grid-chk  .v-input--selection-controls__input i.v-icon.primary--text {
    color: #ffffff !important;
    background: var(--v-accent-base) !important;
}
.activity-grid-chk  .v-input--selection-controls__input i.v-icon.primary--text:before {
    content: "\F012C";    font-size: 20px;
}

.activity-grid {
    border: 3px solid var(--v-accent-base) !important;
}
.hub-activity .v-responsive {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
}
.activity-grid {
  border: 3px solid var(--v-accent-base) !important;
}
</style>
